import { useState } from 'react';

import { sortByPlaceAtAsc } from 'features/order/scheduled/domain';
import type { ScheduledOrder } from 'features/order/scheduled/domain';
import { useScheduledOrdersQuery } from 'features/order/scheduled/hooks';

export function useScheduledOrdersList() {
  const { isLoading, isError, data, refetch } = useScheduledOrdersQuery();
  const [selectedOrderId, setSelectedOrderId] = useState<number | null>(null);

  const orders = data ? sortByPlaceAtAsc(data) : [];
  const count = orders.length;

  const handleCardClick = (order: ScheduledOrder) => {
    setSelectedOrderId(order.orderId);
  };

  const handleDialogClose = () => {
    setSelectedOrderId(null);
  };

  return {
    isLoading,
    isError,
    refetch,
    orders,
    count,
    selectedOrderId,
    handleCardClick,
    handleDialogClose,
  };
}
